export default "__VITE_ASSET__piM2nwEe__"